export const OPINION_GUIDE_HIDE = '__db_opinion_guide_hide__';
export const OPINION_GUIDE_BOX_LIST1 = '__db_opinion_guide_list1__';
export const OPINION_GUIDE_BOX_LIST2 = '__db_opinion_guide_list2__';
export const OPINION_GUIDE_BOX_LIST3 = '__db_opinion_guide_list3__';
export const OPINION_GUIDE_BOX_LIST4 = '__db_opinion_guide_list4__';
export const OPINION_GUIDE_BOX_LIST5 = '__db_opinion_guide_list5__';
export const OPINION_GUIDE_BOX_LIST6 = '__db_opinion_guide_list6__';

export const OPINION_GUIDE_BOX_LIST1_PATH = '/opinion/Overview/KeyMetrics';
export const OPINION_GUIDE_BOX_LIST2_PATH = '/opinion/Feeds/Feeds';
export const OPINION_GUIDE_BOX_LIST3_PATH = '/opinion/GameStore';
export const OPINION_GUIDE_BOX_LIST4_PATH = '/opinion/Community/Video';
export const OPINION_GUIDE_BOX_LIST5_PATH = '/search?kw=pubg';
export const OPINION_GUIDE_BOX_LIST6_PATH = '/opinion/DataMap/OpinionsSources';
